// extracted by mini-css-extract-plugin
var _1 = "LayoutHeaderSearchButton-moduleLayoutHeaderSearchButton__PCyqO";
export { _1 as "LayoutHeaderSearchButton" }
